import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AboutWhat.css'; // Keep your styles here

const AboutWhat = () => {
  const navigate = useNavigate();

  const handleReadMoreClick = () => {
    navigate('/thermography');
  };

  return (
    <>
      <section className="about-why py-5">
        <div className="container">
          <h1 className="text-center mb-4 montserrat-font">Why Choose Breast Infrared?</h1>
          <div className="why-thermal-line"></div>
          
          <p className="poppins-font">
            Breast Infrared is an advanced imaging technique that captures heat patterns and blood flow within breast tissue using infrared technology. Unlike mammography, which detects structural changes, Infrared focuses on physiological changes, identifying early warning signs before lumps or tumors develop. This makes it an excellent tool for proactive breast health monitoring.
          </p>

          <p className="poppins-font">
            The process is simple, quick, and entirely painless. A high-resolution infrared camera takes images of the breast area without any contact or radiation exposure. These infrared images are then analyzed by experts to detect temperature variations that could indicate inflammation, abnormal cell activity, or vascular changes linked to potential breast conditions. Because cancerous tissues often have increased blood supply and metabolic activity, Infrared can reveal subtle changes long before they become clinically detectable.
          </p>

          <p className="poppins-font">
            This method is particularly useful for younger women, individuals with a family history of breast cancer, and those seeking a radiation-free screening option. Breast Infrared is also beneficial for ongoing monitoring, allowing doctors to track changes over time and recommend appropriate preventive measures. While it does not replace mammograms or ultrasounds, it serves as a powerful complementary tool that enhances early detection strategies and improves overall breast health management.
          </p>

          <div className="text-center mt-4">
            <button className="btn gradient-btn" onClick={handleReadMoreClick}>
              Read More ➜
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutWhat;
